import React from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

@withTranslation()
class SelfCareItem extends React.Component {
    getOptionalParts = () => {
        const {
            data: { comment },
        } = this.props;
        return { comment };
    };

    render() {
        const { comment } = this.getOptionalParts();
        return (
            <div className="history-item">
                <div className="history-item-content">
                    <div className="history-title-text">
                        <i className="icon-envelope" />
                    </div>
                    <div className="history-content-text">{comment}</div>
                </div>
            </div>
        );
    }
}

SelfCareItem.propTypes = {
    data: PropTypes.object,
};

export default SelfCareItem;
